<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
  id="vertical-nav"
  class="bg-white light print:hidden"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="getNavigation()"
  [opened]="!isScreenSmall">
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <div class=" items-center text-center pl-6 p-1">
      <div class="block items-center text-center mt-4">
        <img class="w-24" src="assets/images/logo/logo-full.png">
      </div>
      <!-- Components -->
      <div class="flex items-center ml-auto">
      </div>
    </div>
    <!-- User -->
    <div class="flex flex-col items-center w-full p-4">
    </div>
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

  <!-- Header -->
  <div
    class="relative flex flex-0 items-center justify-between w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
    <!-- Navigation toggle button -->
    <button
      mat-icon-button
      (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:ellipsis-vertical'"></mat-icon>
    </button>

    <div class="flex items-center">
      <user [showAvatar]="false"></user>
    </div>

  </div>

  <!-- Content -->
  <div class="flex flex-col flex-auto">
    @if (true) {
      <router-outlet></router-outlet>
    }

  </div>

</div>
